<div
    class="agpr-email-account-connector"
    [agprLoading]="loading"
>
    <span
        class="agpr-email-account-connector-icon fa-kit fa-agpr-data-connection"
        aria-hidden="true"
    ></span>
    <span>
        {{ 'DataConnector.emailAccountConnectionInProgress' | localize }}
    </span>
</div>
